export default {
  text: {
    order_cancelled: 'Commande annulée - Aucun livreur disponible',
    wolt_support: 'Des questions ? Appelez Wolt directement <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT :</strong> Acceptez ou refusez cette commande immédiatement',
  },
  labels: {
    dummy_order: 'Commande test',
    items_one: '{{count}} article',
    items_other: '{{count}} articles',
    needs_acceptance: "En attente d'acceptation",
    driver_pending: "En attente d'un livreur",
    today: "Aujourd'hui",
    driver_assigned: 'Livreur assigné',
    complete: 'Terminée',
  },
  buttons: {
    complete_order: 'Marquer comme terminée',
    looking_for_driver: "Recherche d'un livreur...",
    click_to_remove: 'Cliquer pour supprimer',
  },
};
